import React from "react";
import { SelectField, InputField } from "./fields.jsx";
import htmlToDom from "html-react-parser";

class Room extends React.Component {
  index = this.props.index;
  unitIndex = this.props.unitIndex;
  removeDynamicField(type, object) {
    this.props.removeDynamicField("rooms", object);
  }
  render() {
    return (
      <div className="unit-dynamic-field-edit">
        <span
          className="pe-1 pr pointer action-remove"
          onClick={() => {
            this.removeDynamicField("rooms", this.props.room);
          }}
          title={window.Translator.trans("units.buttons.remove", {}, "js")}
        >
          <svg className="icon remove" width="12" height="12">
            <use href="#remove"></use>
          </svg>
        </span>
        <div className="row gx-3">
          <div className="col-6 col-sm-3 col-lg-3 col-xl-2">
            <div className="mdc-text-field select-field">
              {htmlToDom(this.props.room.type.label)}
              <span className="caret"></span>
              <SelectField field={this.props.room.type} />
            </div>
          </div>
          <div className="col-6 col-sm-2">
            <div className="mdc-text-field text-field">
              {htmlToDom(this.props.room.single_beds.label)}
              <InputField field={this.props.room.single_beds} />
            </div>
          </div>
          <div className="col-6 col-sm-2">
            <div className="mdc-text-field text-field">
              {htmlToDom(this.props.room.double_beds.label)}
              <InputField field={this.props.room.double_beds} />
            </div>
          </div>
          <div className="col-6 col-sm-2">
            <div className="mdc-text-field text-field">
              {htmlToDom(this.props.room.day_beds.label)}
              <InputField field={this.props.room.day_beds} />
            </div>
          </div>
          <div className="col-6 col-sm-2">
            <div className="mdc-text-field text-field">
              {htmlToDom(this.props.room.other_beds.label)}
              <InputField field={this.props.room.other_beds} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Room;
